import React, {Fragment, useEffect, useState} from "react";
import withLanguage from "../../../HOC/withLanguage";
import {useSelector} from "react-redux";
import axios from "axios";
import Carousel from "react-multi-carousel";
import YoutubeEmbed from "../../Shared/Layout/YoutubeEmbed";



const imgResponsive = {
    desktop: {breakpoint: {max: 3000, min: 1024}, items: 3},
    tablet: {breakpoint: {max: 1024, min: 640}, items: 2},
    mobile: {breakpoint: {max: 640, min: 0}, items: 1},
};


function VideoInputSection({language, endpoint, truncateAt = 100}) {


    const [data, setData] = useState([]);
    const [records, setRecords] = useState([]);
    const lang = useSelector(state => state.language.currentLanguage)

    let apiPath = "keshilla_karriere"

    useEffect(() => {
        const ac = new AbortController();

        fetch(`/api/data_video/video/${apiPath}?lang=${encodeURIComponent(lang)}`, {signal: ac.signal})
            .then(async (r) => {
                if (!r.ok) throw new Error(`HTTP ${r.status}`);
                return r.json();
            })
            .then((data) => setRecords(Array.isArray(data?.records) ? data.records : []))
            .catch((e) => {
                console.log(e)
            })

        return () => ac.abort();
    }, [apiPath, lang]);

    useEffect(() => {

        const fetchData = async () => {
            await axios.get("/api/student_dual_images/student_dual_images").then((response) => {
                setData(response.data.records);
            }).catch((error) => {
                console.log(error);
            })
        }

        fetchData();
    }, [])

    console.log(data)



    return (

        <div className="bg-[#7B6668] max-w-6xl text-white mx-auto px-4 py-8">
            <div className="max-w-6xl mx-auto px-4">

                {/* Section title */}
                <h2 className="text-3xl md:text-4xl font-extrabold text-center mb-4 mt-10">
                    {language.mainTitle3}
                </h2>

                <p className="text-white text-center mb-12 text-lg md:text-xl max-w-3xl mx-auto">
                    {language.subText3}
                </p>


                {/* Carousel */}
                <Carousel responsive={imgResponsive}>
                    {[...records, ...records, ...records, ...records].map((rec, i) => (
                        <div key={i} className="w-full aspect-video mb-4">
                            <YoutubeEmbed embedId={rec.url} height={300}/>
                        </div>
                    ))}
                </Carousel>
            </div>
        </div>

    );
}


export default withLanguage(VideoInputSection, "VideoInputSection");
